export default "__VITE_ASSET__0b6a8c49__"